import React, { Component, Fragment } from 'react';
import { ClipLoader, BarLoader } from 'react-spinners';
import axios from 'axios';
import EventItem from './EventItem';
import EventFilter from './EventFilter';
import history from "../../../history";
import Pagination from 'react-js-pagination';
// import '../../sass/modules/pagination.scss';
import { Scrollbars } from 'react-custom-scrollbars';
import PublicTagLinks from '../../PublicTagLinks';
import { NavLink } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_API_URL+'api';
const API_URL = process.env.REACT_APP_API_URL+'api/events';

class EventTaggedList extends Component {
	
	constructor(props) {
		super(props);
		this.state = { 
			events: [],
			next_page: API_URL,
			loading: false,
			filtered: false,
			init_load_more: false,
			pagination: [],
			tag: this.props.tag,
			tags:[],
			event: {
				title: '',
				type: 0,
				organisation_title: '',
				artsmark_partner: 0,
				support_send: 0,
				keystages: [],
				artform: 0,
				venue_name: '',
				postcode: '',
				status: 'active',
				sort: 'start',
				free: 0,
				visible: 1,
				page: 1
			}
	}
}

	componentDidMount() {
		this.init();
		this.getPublicTags();
		this.eventFilter = React.createRef();
		this.scrollInto = React.createRef();
	}

	init() {
		if(this.props.tag && !this.state.loading) {
			this.setState({
				loading: true
			});

			console.log(API_URL+'/tags/'+this.state.tag);

			axios.get(API_URL+'/tags/'+this.state.tag, {
					status: 'active',
					visible: this.state.event.visible,
					page: this.state.event.page
				})
				.then(response => {
					const pagination = response.data.meta.pagination;
					const events = response.data.data;

					if (this.state.pagination.total_pages >= this.state.pagination.current_page) {
						this.setState({
							events: events,
							loading: false,
							pagination: pagination,
							init_load_more: true
						}, () => {
							const url = window.location.href;

							this.saveState(url, this.state.events, this.state.event.page, this.state.pagination);
							this.events();
						});
					} else {
						this.setState({
							events: events,
							loading: false,
							pagination: pagination,
							init_load_more: false
						}, () => {
							const url = window.location.href;

							this.saveState(url, this.state.events, this.state.event.page, this.state.pagination);
							this.events();
						});				
					}
				});
		}
	}

	events() {
		if (window.location.search.indexOf('page') > 0) {
			const url = new URL(window.location.href);
			const page = url.searchParams.get('page');

			axios.post(API_URL+'/filter', { 
					status: 'active',
					visible: 1,
					page: page,
				})
				.then(response => {
					const events = response.data.data;
					const pagination = response.data.meta.pagination;

					this.setState(
						prevState => ({
							events: events,
							loading: false,
							pagination: pagination,
							init_load_more: false,
							event: {
								...prevState.event,
								page: parseInt(page)
							}
						}), () => {
							const url = window.location.href;

							this.saveState(url, this.state.events, this.state.event.page, this.state.pagination);
						}
					);
				});
		}

		window.addEventListener("popstate", (e) => {
			if (e.state !== null) {
				this.setState(
					prevState => ({
						...prevState,
						events: e.state.filtersHtml,
						event: {
							...prevState.event,
							page: e.state.page
						},
						pagination: e.state.pagination
					})
				);				
			}
		});
	}

	onClearFilter = () => {
		history.push("/events");
		// this.setState(this.state, () => {
		// 	this.init();
		// 	this.eventFilter.current.getArtformTypes();
		// });
	};

	

	onFilteredResults = (props) => {
		this.setState({
			events: [],
			init_load_more: false,
			loading: true,
			filtered: true,
			tag: '',
			event: {
				keyword: props.event.keyword,
				type: props.event.type,
				organisation_title: props.event.organisation_title,
				support_send: props.event.support_send,
				keystages: props.event.keystages,
				postcode: props.event.postcode,
				artform: props.event.artform,
				distance: props.event.distance,
				sort: props.event.sort,
				free: props.event.free,
				status: this.state.event.status,
				visible: this.state.event.visible,
				page: props.page,				
			}
		}, () => {
			this.getFilteredResults();
		});
	}

	getFilteredResults = () => {

		

		axios.post(API_URL+'/filter', {
			keyword: this.state.event.keyword,
			type: this.state.event.type,
			organisation_title: this.state.event.organisation_title,
			support_send: this.state.event.support_send,
			keystages: this.state.event.keystages,
			postcode: this.state.event.postcode,
			artform: this.state.event.artform,
			sort: this.state.event.sort,
			distance: this.state.event.distance,
			status: this.state.event.status,
			free: this.state.event.free,
			visible: this.state.event.visible,
			page: this.state.event.page,
		})
		.then(response => {
			const events = response.data.data;
			const pagination = response.data.meta.pagination;

			if (this.state.pagination.total_pages >= this.state.pagination.current_page) {
				this.setState({
					events: events,
					loading: false,
					pagination: pagination,
				}, () => {
					const href = window.location.href;
		            let url = href + '?page=' + this.state.event.page;
					
					if (window.location.search.indexOf('page') > 0) {
						const page = this.state.event.page;
						url = '?page=' + page;
					}

					this.saveState(url, this.state.events, this.state.event.page, this.state.pagination);
				});
			} else {
				this.setState({
					events: events,
					loading: false,
					pagination: pagination,
				});				
			}
		});
	};

	getPublicTags = () => {
		axios.get(BASE_URL + "/get-public-tags").then((response) => {
			this.setState(
				prevState => ({
					...prevState,
					tags: response.data.data
				})
			);				
		});
	  };

	handleSortOrderChange = (e, sort) => {

			this.setState(
				prevState => ({
					...prevState,
					tag: '',
					event: {
						...prevState.event,
						sort: sort
					}
				}), () => {
					this.getFilteredResults();
					this.scrollInto.current.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
				}
			)
	}

	handlePageChange = (pageNumber, ref) => {
		this.setState(
			prevState => ({
				...prevState,
				event: {
					...prevState.event,
					page: pageNumber
				},
				pagination: {
					...prevState.pagination,
					current_page: pageNumber
				}
			}), () => {
				this.getFilteredResults();
				this.scrollInto.current.scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				});
			}
		)
	}

	saveState(url, container, page, pagination) {
		window.history.pushState({
			path: url,
			filtersHtml: container,
			page: page,
			pagination: pagination
		}, 'Event list', url);
	}

	renderLoadmore() {
		if (this.state.pagination.total_pages > this.state.pagination.current_page || this.state.init_load_more) {
			return (
				<div className="container">
					<div className="d-flex justify-content-center align-items-center py-1 py-md-4">						
						<button onClick={this.onLoadMore} className="btn btn-primary btn-lg">
							Load More <div className="loading-spinner">
							<BarLoader
								color={'#FFF'}
								loading={this.state.loading}
							/>
						</div></button>
					</div>
				</div>
			);
		}
	};

	renderResults() {
		if (this.state.events.length) {
			return (
				this.state.events.map(event => 
					<EventItem key={event.id} event={event}/>
				)
			);
		}

		if (!this.state.loading) {
			return (
				<div className="container">
					<div className="d-flex justify-content-center align-items-center py-4">
						<h1>No results found</h1>
					</div>
				</div>
			);			
		}
	}

	renderLoadFinalResult() {
		if (this.state.loading) {
			return (
				<div className="container py-10">
					<div className="d-flex justify-content-center align-items-center py-4">
						<div className="loading-spinner">
							<ClipLoader
								color={'#28A2FB'}
								size={100}
								loading={true}
							/>
						</div>
					</div>
				</div>
			);
		} else {
			return (
				<Fragment>
						{this.renderSorting()}
					<section id="tabResults" className="tab-results" ref={this.scrollInto}>
						{ this.renderPagination() }
						{ this.renderResults() }
						{ this.renderPagination() }
					</section>
				</Fragment>
			);
		}
	}

	renderPagination() {
		const pagination = this.state.pagination;

		if (pagination.total_pages > 1) {
			return (
				<section className="bg-grey">
					<div className="container">
						<nav aria-label="Pagination nav">
							<Scrollbars autoHide autoHeight>
								<Pagination 
									activePage={pagination.current_page}
									itemsCountPerPage={pagination.per_page}
									totalItemsCount={pagination.total}
									pageRangeDisplayed={pagination.total_pages}
									onChange={this.handlePageChange}
									itemClass="page-item"
									linkClass="page-link"
									firstPageText={<span className="fa fa-angle-double-left"></span>}
									lastPageText={<span className="fa fa-angle-double-right"></span>}
									nextPageText={<span className="fa fa-angle-right"></span>}
									prevPageText={<span className="fa fa-angle-left"></span>}
								/>
							</Scrollbars>
						</nav>
					</div>
				</section>
			)			
		}
	}

	renderNumberResults() {
		const results = this.state.pagination;

		if (this.state.filtered && this.state.event.postcode.length > 0 && this.state.event.sort === 'distance') {
			return (
				<span>
					{results.total} events found by closest to postcode
				</span>
			)
		} else {
			return (
				<span>
					{results.total} events found
				</span>
			)
		}
	}

	renderSorting() {
		return (
			<section className="bg-grey border-bottom">
				<div className="container py-2">
					<div className="row">
						<div className="col">
							<label className="pr-2">SORT</label>
							<button className={'btn btn-sort mr-1' + ((this.state.event.sort === 'title' && this.state.tag === '') ? ' active' : '')} onClick={(e) => this.handleSortOrderChange(e, 'title')}>A-Z</button>
							<button className={'btn btn-sort mr-1' + ((this.state.event.sort === 'start' && this.state.tag === '') ? ' active' : '')} onClick={(e) => this.handleSortOrderChange(e, 'start')}>MOST RECENT</button>
							<button className={'btn btn-sort mr-1' + ((this.state.event.sort === 'random' && this.state.tag === '') ? ' active' : '')} onClick={(e) => this.handleSortOrderChange(e, 'random')}>RANDOM</button>
							
							<PublicTagLinks activity_type={'events'} tag={this.state.tag} />

							{this.renderNumberResults()}
						</div>

					</div>
				</div>
			</section>
		);
	}


	render() {
		console.log(this.state.events);
		return (
			<Fragment>
				<EventFilter 
					ref={this.eventFilter}
					onClearFilter={this.onClearFilter} 
					onFilteredResults={this.onFilteredResults}
				/>

				{ this.renderLoadFinalResult() }
			</Fragment>
		)
	}
}

export default EventTaggedList;